import { UPDATE_JOINTHOLDER_FLOW_SCREEN, UPDATE_JOINTHOLDER_MODAL } from "./jointholderTypes";


export const setShowJointholderModal = (data) => {
  return {
    type: UPDATE_JOINTHOLDER_MODAL,
    data: data,
  };
};
export const updateJointholderFlowScreen = (data) => {
  return {
    type: UPDATE_JOINTHOLDER_FLOW_SCREEN,
    data: data,
  };
};
